/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ElementsVersion
 */
export interface ElementsVersion {
    /**
     * 
     * @type {string}
     * @memberof ElementsVersion
     */
    release: string;
    /**
     * 
     * @type {string}
     * @memberof ElementsVersion
     */
    branch: string | null;
    /**
     * 
     * @type {number}
     * @memberof ElementsVersion
     */
    patchCount: number;
    /**
     * 
     * @type {number}
     * @memberof ElementsVersion
     */
    patchCommitCount: number;
    /**
     * 
     * @type {string}
     * @memberof ElementsVersion
     */
    commit: string | null;
}

export function ElementsVersionFromJSON(json: any): ElementsVersion {
    return ElementsVersionFromJSONTyped(json, false);
}

export function ElementsVersionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ElementsVersion {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'release': json['release'],
        'branch': json['branch'],
        'patchCount': json['patch_count'],
        'patchCommitCount': json['patch_commit_count'],
        'commit': json['commit'],
    };
}

export function ElementsVersionToJSON(value?: ElementsVersion | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'release': value.release,
        'branch': value.branch,
        'patch_count': value.patchCount,
        'patch_commit_count': value.patchCommitCount,
        'commit': value.commit,
    };
}


